import React from "react";
import s from "../../layers-menu.module.scss";
import { Layer } from "../../../../../interfaces/layer";
import { DebouncedFunction } from "../../../useDebounceLayers";
import Checkbox from "../../../../ui-kit/checkbox/checkbox";

interface Props {
  modelCheckboxesLayers: Layer[];
  debounce: DebouncedFunction;
  handleChangeSelectedItems: (
    id: number,
    checked: boolean,
    type: "checkbox",
  ) => void;
  allSelected: number[];
}

export default function ModelCheckboxes({
  modelCheckboxesLayers,
  debounce,
  handleChangeSelectedItems,
  allSelected,
}: Props) {
  return (
    <div className={s.modelsCheckboxes}>
      {modelCheckboxesLayers.map((item, idx) => (
        <label className={s.checkboxLabel} key={idx}>
          <Checkbox
            checked={allSelected.includes(item.id)}
            onChange={(checked) => {
              handleChangeSelectedItems(item.id, checked, "checkbox");
              debounce(item.id, checked, "checkbox/infrastructure");
            }}
          />
          <span className={s.checkboxText}>{item.label}</span>
        </label>
      ))}
    </div>
  );
}
